// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"629a8515","455":"0b3efe82"}[chunkId] + ".chunk.js";
};